import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

const appStoreLinkUrl = "https://api.mikmic.com/api/app-store-link";
const redirectToAppStoreLink = (to, from, next) => {
  window.location.replace(appStoreLinkUrl);
  next(false);
};

export default new Router({
  mode: 'history',
  routes: [
    {
      path: "/app",
      beforeEnter: redirectToAppStoreLink
    },
    {
      path: "/app-store-link",
      beforeEnter: redirectToAppStoreLink
    },
    {
      path: "/",
      component: () => import("@/layouts/MainLayout"),
      children: [
        {
          path: "",
          component: () => import("@/views/Home")
        },
        {
          path: "about",
          component: () => import("@/views/About")
        },
        {
          path: "faq",
          component: () => import("@/views/Faq")
        },
        {
          path: "drivers",
          redirect: "/faq"
        },
        {
          path: "deleteAccount",
          component: () => import("@/views/DeleteAccount")
        },
        {
          path: "advertising",
          component: () => import("@/views/Advertising")
        },
      ]
    },
    {
      path: '/:catchAll(.*)*',
      redirect: to => {
        return { path: '/' }
      },
    }
  ]
});
